module.exports = __webpack_public_path__ + "static/media/email-icon.349f5cff.svg";